
import { preventRightClick } from './utils';

export const initRightClickProtection = (lightbox) => {
  lightbox.on('bindEvents', () => {
    lightbox.pswp.container.addEventListener('contextmenu', preventRightClick);
  });

  lightbox.on('unbindEvents', () => {
    lightbox.pswp.container.removeEventListener('contextmenu', preventRightClick);
  });
};